import React, { Component } from "react";
import { Alert, Container, Table } from "reactstrap";
import { RouterProps } from "../../../toolkit/decorators/Artifact";
import FormBuilder from "../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./CancelacionesProceso.form";
import { CancelacionesProcesoTable } from "./CancelacionesProceso.table";
import { CancelacionesProcesoDispatcher } from "../../containers/cancelacionesProceso/CancelacionesProceso.dispatcher";
import { CancelacionesProcesoStore } from "../../containers/cancelacionesProceso/CancelacionesProceso.store";
import {
  errorNotification,
  successNotification
} from "../../../utils/notifications";
import { Preview } from "../../../types/IAction";
import ModalFrame from "../../../toolkit/modalFrame";
import ConfirmModal from "../common/confirmModal/confirmModal";
import { formatIsoDate } from "../../helpers/formatters";

interface Props
  extends CancelacionesProcesoDispatcher,
    CancelacionesProcesoStore,
    RouterProps {}

interface State {
  modalIntentosOpen: boolean;
  selectedFacturaId: number | null;
  confirmModalOpen: boolean;
  selectedUuidCancelacion: string | null;
  confirmReenvioModalOpen: boolean;
  selectedUuidReenvio: string | null;
}

export default class CancelacionesProcesoComponent extends Component<
  Props,
  State
> {
  state: State = {
    modalIntentosOpen: false,
    selectedFacturaId: null,
    confirmModalOpen: false,
    selectedUuidCancelacion: null,
    confirmReenvioModalOpen: false,
    selectedUuidReenvio: null
  };

  submit = async (data: { [key in Inputs]: any }) => {
    this.lastSearchParams = data;
    const { tipoBusqueda, mes, anio, folioFactura } = data;

    if (!tipoBusqueda) {
      const periodo = `${anio || new Date().getFullYear()}-${mes}-01`;
      const preview = await this.props.getCancelacionesByPeriodo(periodo);

      if (!preview.fulfilled) {
        errorNotification(preview.gettingCancelacionesProcesoError);
      }
    } else if (tipoBusqueda === "factura") {
      const preview = await this.props.getCancelacionesByFolio(folioFactura);

      if (!preview.fulfilled) {
        errorNotification(preview.gettingCancelacionesProcesoError);
      }
    }
  };

  handleVerIntentos = async (idFactura: number) => {
    this.setState({
      selectedFacturaId: idFactura,
      modalIntentosOpen: true
    });

    const preview = await this.props.getCancelacionesIntentosByFactura(
      idFactura
    );

    if (!preview.fulfilled) {
      errorNotification(preview.gettingCancelacionesIntentosError);
    }
  };

  toggleModal = () => {
    this.setState({ modalIntentosOpen: false, selectedFacturaId: null });
  };

  handleVerificarCancelacion = async (uuidCancelacion: string) => {
    const preview = await this.props.postVerificarCancelacion(uuidCancelacion);

    if (preview.fulfilled) {
      successNotification("Cancelación confirmada");
      this.submit(this.getLastSearchParams());
    } else {
      errorNotification(preview.postingVerificarCancelacionError);
    }
  };

  handleConfirmarCancelacion = (uuidCancelacion: string) => {
    this.setState({
      confirmModalOpen: true,
      selectedUuidCancelacion: uuidCancelacion
    });
  };

  confirmCancelacion = async () => {
    const { selectedUuidCancelacion: uuid } = this.state;

    if (!uuid) return;

    const preview = await this.props.postConfirmarCancelacion(uuid);
    if (preview.fulfilled) {
      successNotification("Cancelación confirmada manualmente");

      this.setState({
        confirmModalOpen: false,
        selectedUuidCancelacion: null
      });

      this.submit(this.getLastSearchParams());
    } else {
      errorNotification(preview.postingConfirmarCancelacionError);
    }
  };

  cancelConfirmModal = () => {
    this.setState({ confirmModalOpen: false, selectedUuidCancelacion: null });
  };

  handleReenviarSolicitud = (uuidCancelacion: string) => {
    this.setState({
      confirmReenvioModalOpen: true,
      selectedUuidReenvio: uuidCancelacion
    });
  };

  confirmReenvioSolicitud = async () => {
    const { selectedUuidReenvio: uuid } = this.state;

    if (!uuid) {
      return;
    }

    const preview = await this.props.postReenviarSolicitudCancelacion(uuid);
    if (preview.fulfilled) {
      successNotification("Solicitud de cancelación reenviada correctamente");

      this.setState({
        confirmReenvioModalOpen: false,
        selectedUuidReenvio: null
      });

      this.submit(this.getLastSearchParams());
    } else {
      errorNotification(preview.postingReenviarSolicitudCancelacionError);
    }
  };

  cancelReenvioModal = () => {
    this.setState({
      confirmReenvioModalOpen: false,
      selectedUuidReenvio: null
    });
  };

  lastSearchParams: Partial<{ [key in Inputs]: any }> = {};

  getLastSearchParams = () => {
    return this.lastSearchParams as { [key in Inputs]: any };
  };

  render() {
    const {
      modalIntentosOpen,
      confirmModalOpen,
      confirmReenvioModalOpen
    } = this.state;
    const {
      cancelacionesProceso,
      gettingCancelacionesProceso,
      cancelacionesIntentos,
      gettingCancelacionesIntentos,
      gettingCancelacionesIntentosError,
      postingVerificarCancelacion,
      postingConfirmarCancelacion,
      postingReenviarSolicitudCancelacion
    } = this.props;

    const loading =
      gettingCancelacionesProceso ||
      postingVerificarCancelacion ||
      postingConfirmarCancelacion ||
      postingReenviarSolicitudCancelacion;

    return (
      <Container>
        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          submit={this.submit}
          processing={loading}
        />

        <CancelacionesProcesoTable
          data={cancelacionesProceso}
          loading={loading}
          onVerIntentos={this.handleVerIntentos}
          onVerificarCancelacion={this.handleVerificarCancelacion}
          onConfirmarCancelacion={this.handleConfirmarCancelacion}
          onReenviarSolicitud={this.handleReenviarSolicitud}
          postingVerificarCancelacion={postingVerificarCancelacion}
          postingConfirmarCancelacion={postingConfirmarCancelacion}
          postingReenviarSolicitudCancelacion={
            postingReenviarSolicitudCancelacion
          }
        />

        <ModalFrame
          title="Intentos de Verificación de Cancelación"
          isOpen={modalIntentosOpen}
          toggle={() => {
            this.setState({
              modalIntentosOpen: false,
              selectedFacturaId: null
            });
          }}
          size="lg"
        >
          {gettingCancelacionesIntentos && (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Cargando...</span>
              </div>
            </div>
          )}

          {gettingCancelacionesIntentosError && (
            <Alert color="danger">{gettingCancelacionesIntentosError}</Alert>
          )}

          {cancelacionesIntentos &&
            cancelacionesIntentos.length > 0 &&
            !gettingCancelacionesIntentos && (
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>UUID Cancelación</th>
                    <th>Empleado</th>
                    <th>Tipo</th>
                    <th>Fecha Verificación</th>
                    <th>Error</th>
                  </tr>
                </thead>
                <tbody>
                  {cancelacionesIntentos.map((intento, index) => (
                    <tr key={index}>
                      <td style={{ fontSize: "0.75rem" }}>
                        {intento.uuidCancelacion}
                      </td>
                      <td>{intento.empleado}</td>
                      <td>
                        <span
                          className={
                            intento.tipo === "MANUAL"
                              ? "badge badge-primary"
                              : "badge badge-secondary"
                          }
                        >
                          {intento.tipo}
                        </span>
                      </td>
                      <td>{formatIsoDate(intento.fechaVerificacion, true)}</td>
                      <td>
                        {intento.error ? (
                          <span className="text-danger">{intento.error}</span>
                        ) : (
                          <span className="text-success">Sin error</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}

          {cancelacionesIntentos &&
            cancelacionesIntentos.length === 0 &&
            !gettingCancelacionesIntentos && (
              <Alert color="info">
                No se encontraron intentos de verificación para esta factura.
              </Alert>
            )}
        </ModalFrame>

        <ConfirmModal
          isOpen={confirmModalOpen}
          title="Confirmar Cancelación Manual"
          message="Confirme que el SAT ha cancelado la factura"
          waiting={postingConfirmarCancelacion}
          ok={this.confirmCancelacion}
          cancel={this.cancelConfirmModal}
          size="md"
        />

        <ConfirmModal
          isOpen={confirmReenvioModalOpen}
          title="Reenviar Solicitud de Cancelación"
          message="¿Está seguro de reenviar la solicitud de cancelación?"
          waiting={postingReenviarSolicitudCancelacion}
          ok={this.confirmReenvioSolicitud}
          cancel={this.cancelReenvioModal}
          size="md"
        />
      </Container>
    );
  }
}
